<template>
  <button-dialog-container
    :btn-icon="icon"
    :only-icon="true"
    :width-dialog="800"
    :size="getSize"
    :dialog-viewer.sync="dialog"
    :no-tool-tip="noToolTip"
    :title-tool-tip="titleToolTip"
    @ok-pushed="returnText"
    @cancel-pushed="outsideClick"
    @outside-click="outsideClick"
  >
    <text-editor
      :value.sync="content"
      class="mt-4"
    />
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";
import textEditor from "../Common/TextEditor";

export default {
  components: {
    buttonDialogContainer,
    textEditor,
  },
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    getSize: {
      type: Number,
      default: 25,
    },
    icon: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: true,
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    toolName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      content: "",
      dialog: false,
    };
  },
  computed: {
    open() {
      return this.$store.state.widget.openEditText;
    },
  },
  watch: {
    open: function () {
      if (this.open) {
        this.dialog = true;
        this.dblclick = true;
        this.$nextTick(() => {
          this.content = this.currentObject.text;
        });
        this.$store.dispatch("editClose").widget;
      }
    },
    //check when dialog is opened to set the content value to the current object text
    dialog(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.content = this.currentObject.text;
          }, 100);
        });
      }
    },
  },
  methods: {
    outsideClick() {
      this.content = "";
      this.dblclick = false;
    },
    returnText() {
      if (this.content.length > 0) {
        if (!this.dblclick) {
          if (this.toolName) {
            this.$emit("toolSelectedFromDialog", this.toolName);
          }
          this.$emit("textEdit", this.content);
        } else if (this.dblclick) {
          this.$emit("textEditElement", {
            name: "text",
            content: this.content,
            config: this.currentObject.konvaObjectOption,
          });
          this.dblclick = false;
        }
      }

      this.outsideClick();
    },
  },
};
</script>

<style></style>
